var _path, _g, _path2, _g2, _path3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleGrafirsm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 752,
    viewBox: "0 0 540 752",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: 284,
    width: 465,
    height: 466
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.19781 286.768C116.278 287.718 232.46 336.635 318.03 422.863C403.6 509.091 451.63 625.641 451.65 747.122L-8.7998 747.198L-5.19781 286.768Z",
    fill: "url(#paint0_radial_236_220)",
    fillOpacity: 0.45,
    stroke: "#2970FF",
    strokeOpacity: 0.4,
    strokeWidth: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.19781 286.768C116.278 287.718 232.46 336.635 318.03 422.863C403.6 509.091 451.63 625.641 451.65 747.122L-8.7998 747.198L-5.19781 286.768Z",
    fill: "url(#paint1_radial_236_220)",
    fillOpacity: 0.45,
    stroke: "#2970FF",
    strokeOpacity: 0.4,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_236_220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -12,
    y: -1,
    width: 751,
    height: 753
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.64001 2C91.194 2.3098 188.009 21.8865 278.28 59.6127C368.55 97.3377 450.5 152.475 519.46 221.873C588.42 291.271 643.04 373.573 680.19 464.079C717.34 554.584 736.31 651.522 736 749.356L-9 746.997L-6.64001 2Z",
    fill: "url(#paint2_radial_236_220)",
    fillOpacity: 0.45,
    stroke: "#2970FF",
    strokeOpacity: 0.4,
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_236_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.64001 2C91.194 2.3098 188.009 21.8865 278.28 59.6127C368.55 97.3377 450.5 152.475 519.46 221.873C588.42 291.271 643.04 373.573 680.19 464.079C717.34 554.584 736.31 651.522 736 749.356L-9 746.997L-6.64001 2Z",
    fill: "url(#paint3_radial_236_220)",
    fillOpacity: 0.45,
    stroke: "#2970FF",
    strokeOpacity: 0.4,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_236_220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: 460,
    width: 289,
    height: 291
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.82788 462.792C29.5431 462.897 66.5271 470.361 101.013 484.76C135.499 499.158 166.811 520.208 193.16 546.708C219.51 573.207 240.39 604.639 254.59 639.205C268.79 673.772 276.05 710.796 275.95 748.167L-8.62891 747.367L-7.82788 462.792Z",
    fill: "url(#paint4_radial_236_220)",
    fillOpacity: 0.45,
    stroke: "#2970FF",
    strokeOpacity: 0.4,
    strokeWidth: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_236_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.82788 462.792C29.5431 462.897 66.5271 470.361 101.013 484.76C135.499 499.158 166.811 520.208 193.16 546.708C219.51 573.207 240.39 604.639 254.59 639.205C268.79 673.772 276.05 710.796 275.95 748.167L-8.62891 747.367L-7.82788 462.792Z",
    fill: "url(#paint5_radial_236_220)",
    fillOpacity: 0.45,
    stroke: "#2970FF",
    strokeOpacity: 0.4,
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_236_220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.79982 747.198) rotate(-179.552) scale(460.445 460.445)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#2970FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_236_220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.79982 747.198) rotate(-179.552) scale(460.445 460.445)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#2970FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_236_220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-9 746.997) rotate(-85.5273) scale(745 745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#2970FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_236_220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-9 746.997) rotate(-85.5273) scale(745 745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#2970FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_236_220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.6289 747.367) rotate(-108.511) scale(284.577 284.577)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#2970FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_236_220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.6289 747.367) rotate(-108.511) scale(284.577 284.577)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#2970FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGrafirsm);
export default __webpack_public_path__ + "static/media/circle-grafirsm.42f6d750dbe91d4f3cab0a5f80b6d587.svg";
export { ForwardRef as ReactComponent };